module.exports = __webpack_public_path__ + "img/bundles-Custom.4fed82ae.png";